import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hp-buttons-controlers-steps',
  templateUrl: './buttons-controlers-steps.component.html',
  styleUrls: ['./buttons-controlers-steps.component.css']
})
export class ButtonsControlersStepsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
